import { Component } from '@angular/core';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { FichaProductosFundsComponent } from 'src/app/home/porque-my-investor/ficha-productos-funds/ficha-productos-funds.component';

@Component({
  selector: 'app-porque-my-investor',
  standalone: true,
  imports: [SharedModule, FichaProductosFundsComponent],
  templateUrl: './porque-my-investor.component.html',
  styleUrls: ['./porque-my-investor.component.scss']
})
export class PorqueMyInvestorComponent
{

}
